import { createApp } from 'vue';
import { createPinia } from 'pinia';
import './assets/styles.css';
import '@/types/globals.d.ts';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import Loader from '@ui/Loader.vue';
import App from './App.vue';
import router from './router';

dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(advancedFormat);

// Make dayjs available globally
(window as any).$dayjs = dayjs;

// Create the Vue app
const app = createApp(App);

// Use Pinia for state management
app.use(createPinia());

// Use Vue Router for routing
app.use(router);

// Register global components
app.component('Loader', Loader);

// Define and assign filters
// TODO: need to figure out TS issues
app.config.globalProperties.$filters = {
  formatDayjs(date: Date) {
    return dayjs(date).format('MMM DD, YYYY');
  },
};

app.mount('#app');
